import React, { useEffect, useState } from 'react'
import { Grid, Grow, Container } from "@material-ui/core";
import PostForm from './PostForm';
import Posts from './posts/Posts';
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "./../redux/actions/post";

const Home = () => {
    const posts = useSelector(state => state.posts);
    const dispatch = useDispatch();
    const [currentId, setCurrentId] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => dispatch(fetchPosts()), []);

    return (
        <div>
            <Container maxWidth="lg">
                <Grid container spacing={3}>
                    <Grow in>
                        <Grid item md={3} xs={12} >
                            <PostForm currentId={currentId} setCurrentId={setCurrentId} />

                            <div style={{ textAlign: "center" }}>
                                <br></br>
                                {posts.map((p, i) => {
                                    let r = 0;

                                    if (posts.length / 6 - parseInt(posts.length / 6) > 0) r = 1;

                                    if (i >= 1 && i <= parseInt(posts.length / 6) + r) return (
                                        <span key={i} className={"page " + (i === page && "current_page")} onClick={() => setPage(i)}>
                                            {i}
                                        </span>
                                    );
                                })}
                            </div>
                        </Grid>
                    </Grow>
                    <Grow in>
                        <Grid item md={9} xs={12}>
                            <Posts page={page} setCurrentId={setCurrentId} />
                        </Grid>
                    </Grow>
                </Grid>
            </Container>
        </div>
    )
}

export default Home;